import { actions } from '../constants/announcement';
import * as actionTypes from '../../models/action/announcement';
import * as types from '../../models/pages/announcement';

export function GetUnreadAnnouncementCount(isOnlyCount?: boolean, spinnerId?: string, spinnerType?: 'get' | 'set') : actionTypes.IGetUnreadAnnouncementCount {
    return{
        isOnlyCount,
        timestamp: Date.now(),
        type: actions.GET_UNREAD_ANNOUNCEMENT_COUNT,
        spinnerId,
        spinnerType
    };
}

export function SetUnreadAnnouncementCount(unreadAnnouncementCount?: number, isOnlyCount?: boolean, spinnerId?: string, spinnerType?: 'get' | 'set') : actionTypes.ISetUnreadAnnouncementCount {
    return{
        unreadAnnouncementCount,
        isOnlyCount,
        timestamp: Date.now(),
        type: actions.SET_UNREAD_ANNOUNCEMENT_COUNT,
        spinnerId,
        spinnerType
    };
}

export function GetLoginAnnouncement(organizationId:string) : actionTypes.ILoginAnnouncementGetAction {
    return{
        organizationId,
        timestamp: Date.now(),
        type: actions.LOGIN_ANNOUNCEMENT_GET
    };
}

export function SetLoginAnnouncement(data: types.ILoginAnnouncementModel[] ) : actionTypes.ILoginAnnouncementSetAction {
    return{
        timestamp: Date.now(),
        type: actions.LOGIN_ANNOUNCEMENT_SET,
        loginAnnouncementData: data
    };
}

export function GetLoginAnnouncementById(announcementId: string, spinnerId?: string, spinnerType?: 'get' | 'set', announcementIndex?: number) : actionTypes.ILoginAnnouncementByIdGetAction {
    return{
        announcementId,
        timestamp: Date.now(),
        type: actions.GET_SELECTED_LOGIN_ANNOUNCEMENT,
        spinnerId,
        spinnerType,
        announcementIndex
    };
}

export function SetLoginAnnouncementByIdAction(
    selectedAnnouncement: types.ILoginAnnouncementByIdModel | null,
    selectedAnnouncementIsLoaded: boolean, 
    spinnerId?: string,
    spinnerType?: 'get'|'set',
    announcementIndex?: number
): actionTypes.ISelectedAnnouncementSetAction {
    return {
        selectedAnnouncement,
        selectedAnnouncementIsLoaded,
        timestamp: Date.now(),
        type: actions.SET_SELECTED_ANNOUNCEMENT,
        spinnerId,
        spinnerType,
        announcementIndex
    };
}

export function SetLoginAnnouncementError(isError: boolean) : actionTypes.ISetLoginAnnouncementError {
    return{
        isError,
        timestamp: Date.now(),
        type: actions.SET_LOGIN_ANNOUNCEMENT_ERROR
    };
}